import { gql } from "@apollo/client";
export const AUTH_SAGE_ACCOUNTING = gql`
  mutation authSageAccounting($tenantId:String!,$organisationId: String!,$code: String!) {
    authSageAccounting(tenantId: $tenantId,organisationId: $organisationId,code: $code) {
      success
      message
    }
  }
`;